module.exports = __webpack_public_path__ + "assets/images/879fe80cbcbd76e1e17920161abcd931.svg";